import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { userContext } from './UserContext';
import { useState } from 'react';
import ReportGenerationPage from './pages/ReportGeneration/ReportGeneration';
import LoginPage from './pages/Login/LoginPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import SettingsPage from './pages/Settings/Settings';
import UploadDataPage from './pages/UploadData/UploadData';

function App() {
  const [userInfo, setUser] = useState({
    userInfo: {
      userId: 0,
      userName: '',
      node: '',
      userRole: 0,
  }})
  const value = {userInfo, setUser}
  
  return (
    <section>
        <Router>
            <userContext.Provider value={value}>
              <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/GenerateReport" element={<ReportGenerationPage />} />
                    <Route path="/Settings" element={<SettingsPage />} />
                    <Route path="/UploadData" element={<UploadDataPage />} />
              </Routes>
            </userContext.Provider>
        </Router>
      </section>
  );
}

export default App;
